import styled from "@emotion/styled";
import { border as borderToken, text, surface, brand, spacing, borderRadius, layout, focusRing, controlFontSize } from "@atlas-int/tokens";

const OptionButton = styled.button<any>`
  border: 1px solid ${borderToken.strong};
  margin: 0px;
  padding-left: ${spacing[6]};
  padding-right: ${spacing[6]};
  height: ${layout.controlsHeight};
  cursor: pointer;
  background-color: ${(props: any) => (props.active ? brand.dark : surface.raised)};
  color: ${(props: any) => (props.active ? text.onDark : text.primary)};
  &:hover {
    background-color: ${(props: any) => (props.active ? brand.dark : surface.hover)};
    color: ${(props: any) => (props.active ? text.onDark : text.primary)};
  }
  &:focus-visible {
    outline: ${focusRing.width} ${focusRing.style} ${focusRing.color};
    outline-offset: ${focusRing.offset};
  }
  font-size: ${controlFontSize.default};
  letter-spacing: 0.2px;
`;
const LeftButton = styled(OptionButton)`
  border-top-left-radius: ${borderRadius.base};
  border-bottom-left-radius: ${borderRadius.base};
  border-right: 0px;
  margin-left: ${spacing[10]};
`;

const RightButton = styled(OptionButton)`
  border-bottom-right-radius: ${borderRadius.base};
  border-top-right-radius: ${borderRadius.base};
  border-left: 0px;
`;

interface ShowTableProps {
  /** Whether the table view is currently active */
  showTable: boolean;
  /** Called when the user clicks "Graph View" */
  onShowGraph: () => void;
  /** Called when the user clicks "Table View" */
  onShowTable: () => void;
}

const ShowTable = ({
  showTable,
  onShowGraph,
  onShowTable,
}: ShowTableProps) => {
  return (
    <div>
      <LeftButton
        onClick={onShowGraph}
        active={!showTable}
      >
        Graph View
      </LeftButton>
      <RightButton
        onClick={onShowTable}
        active={showTable}
      >
        Table View
      </RightButton>
    </div>
  );
};
export default ShowTable;
